<template>
  <div class="d-flex align-items-center overflow-hidden">
    <i class="mx-2" :class="item.icon"></i>
    <span class="user-text text-truncate" :title="item.label">{{ item.label }}</span>
  </div>
</template>

<script>
/**
 * This provides the template for the selected items in status filter
 */
export default {
  name: 'StatusPillTemplate',
  props: ['item']
}
</script>
